export const blogPostMicroData = (blogPostUrl, title, subTitle, createdAt) => ({
  '@context': 'https://schema.org/',
  '@type': 'Article',
  mainEntityOfPage: {
    '@type': 'WebPage',
    '@id': blogPostUrl,
  },
  headline: title,
  description: subTitle,
  name: title,
  contentReferenceTime: createdAt,
});
